<template>
  <section class="index-banner">
    <slider ref="slider" class="index-swipe" :options="{ currentPage: 0 }">
      <slideritem @tap="goDetail" v-for="(item, index) in list" :key="index">
        <div class="banner-book-container relative block">
          <div class="absolute tips"><span>客服电话</span> (0531-51756562)</div>
          <img class="banner-book-cover" :src="item.image" alt="" />
          <!-- <div class="banner-text-box no-line-height absolute">
            <h3 class="banner-book-title">开学有新礼</h3>
            <p class="banner-book-desc">山东教育社全新期刊最新上线</p>
            <com-button class="now-buy" label="立即订购>" />
          </div> -->
        </div>
        <!-- <router-link :to="`/goods/detail/${item.book_no}`" class="banner-book-container relative block">
          <img class="banner-book-cover" :src="item.image" alt="" />
          <div class="banner-text-box no-line-height absolute">
            <h3 class="banner-book-title">开学有新礼</h3>
            <p class="banner-book-desc">山东教育社全新期刊最新上线</p>
            <com-button class="now-buy" label="立即订购>" />
          </div>
        </router-link> -->
      </slideritem>
    </slider>
  </section>
</template>

<script>
import { slider, slideritem } from "vue-concise-slider";

export default {
  components: {
    slider,
    slideritem,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    goDetail({ index }) {
      const { $router, list } = this;
      $router.push({
        name: "goods-detail",
        params: {
          id: list[index].book_no,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 首页中间banner
.index-banner {
  width: 5.9rem;
  border-radius: 16px;
  margin: 0 24px;

  .index-swipe {
    height: 100%;
  }
  .index-swipe .banner-book-container {
    width: 100%;
    height: 100%;
    border-radius: 0.16rem;
    overflow: hidden;
    // height: 4.4rem;

    .tips {
      z-index: 1;
      width: 100%;
      padding: 0.12rem 0.24rem 0 0;
      font-size: 0.2rem;
      text-align: right;
      color: #fff;
    }
  }
  .banner-text-box {
    width: 100%;
    bottom: 0;
    left: 0;
    color: #fff;
    text-align: left;
    padding: 0.45rem 0.5rem;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.4)
    );

    .banner-book-title {
      font-size: 0.42rem;
      font-weight: 400;
      font-family: SourceHanSerifCN;
    }
    .banner-book-desc {
      font-size: 0.22rem;
      margin: 0.14rem 0 0.26rem;
    }
    .now-buy {
      font-size: 0.18rem;
      width: 1.37rem;
      height: 0.44rem;
    }
  }
  .index-swipe .banner-book-cover {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    min-height: 100%;
    object-fit: cover;
  }
}

@media (max-width: 768px) {
  .index-banner {
    width: 100%;
    margin: 0;
    border-radius: 0.16rem;
    overflow: hidden;
  }

  .index-banner {
    .banner-text-box {
      padding: 0.5rem 0.56rem;

      .banner-book-title {
        font-size: 0.6rem;
        font-weight: 400;
        font-family: SourceHanSerifCN;
      }
      .banner-book-desc {
        font-size: 0.28rem;
        margin: 0.22rem 0 0.32rem;
      }
      .now-buy {
        font-size: 0.24rem;
        width: 1.8rem;
        height: 0.6rem;
      }
    }
  }
}
</style>
